import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MagazinePage, PAGE_W, PAGE_H } from "@/components/magazine/MagazinePage";

const flip = {
  enter: (d) => ({ rotateY: d > 0 ? 28 : -28, x: d > 0 ? 80 : -80, opacity: 0 }),
  center: { rotateY: 0, x: 0, opacity: 1, transition: { duration: 0.6, ease: [0.645, 0.045, 0.355, 1] } },
  exit: (d) => ({ rotateY: d > 0 ? -28 : 28, x: d > 0 ? -80 : 80, opacity: 0, transition: { duration: 0.32, ease: [0.4, 0, 1, 1] } }),
};

export const Spread = ({ spread, index, direction, zoom, onSwipe }) => {
  const ref = useRef(null);
  const [fit, setFit] = useState(0.5);
  const slots = spread.filter(Boolean).length || 1;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(([e]) => {
      const { width, height } = e.contentRect;
      setFit(Math.min((width - 40) / (slots * PAGE_W), (height - 40) / PAGE_H));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [slots]);

  const s = fit * zoom;
  const W = slots * PAGE_W, H = PAGE_H;
  const touch = useRef(null);

  return (
    <div
      ref={ref}
      className={`spread-viewport ${zoom > 1 ? "zoomed" : ""}`}
      data-testid="spread-viewport"
      onTouchStart={(e) => (touch.current = e.touches[0].clientX)}
      onTouchEnd={(e) => {
        if (touch.current == null) return;
        const dx = e.changedTouches[0].clientX - touch.current;
        if (Math.abs(dx) > 60 && zoom === 1) onSwipe(dx < 0 ? 1 : -1);
        touch.current = null;
      }}
    >
      <div style={{ width: W * s, height: H * s, margin: zoom > 1 ? "20px auto" : 0, position: "relative", flex: "none" }}>
        <div style={{ width: W, height: H, transform: `scale(${s})`, transformOrigin: "0 0", position: "absolute", inset: 0 }}>
          <AnimatePresence mode="wait" custom={direction} initial={false}>
            <motion.div
              key={index}
              custom={direction}
              variants={flip}
              initial="enter"
              animate="center"
              exit="exit"
              className="spread-shadow"
              style={{ width: W, height: H, display: "flex", transformStyle: "preserve-3d", transformOrigin: direction > 0 ? "0% 50%" : "100% 50%", position: "relative", background: "#fff" }}
            >
              {spread.filter(Boolean).map((p) => <MagazinePage key={p.n} page={p} />)}
              {slots === 2 && <div className="spread-fold" />}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};
